module.exports = __webpack_public_path__ + "d39a86d2fe06c5892ff7a5f1cd09a390.png";